import React from "react";
import classNames from "classnames";
import Icon from "../icon/Icon";

// Aviable sizes {xs,sm,md,lg,xl}
/* Aviable theme {blue-dim, blue, azure-dim, azure, indigo-dim, indigo, purple-dim, purple, pink-dim, pink, orange-dim, orange, teal-dim, teal, 
    primary-dim, primary, secondary-dim, secondary, success-dim, success, info-dim, info, warning-dim, warning, danger-dim, danger, dark-dim, dark, gray-dim, gray, lighter, light} */

const UserAvatar = ({
  className,
  name,
  subName,
  clientType,
  email,
  size,
  theme,
  icon,
  text,
  image,
  relations,
  imageAlt,
  phoneNumber,
  avatarText,
  statusBadge,
  customHex,
  capHours,
  ...props
}) => {
  const classes = classNames({
    "user-avatar ": true,
    [`${className}`]: className,
    [`user-avatar-${size} `]: size,
    [`bg-${theme}`]: theme,
  });

  return (
    <div className={`d-flex align-items-center user-card  nk-tb-list ${avatarText}`}>
      <div className={classes} style={{ background: customHex }}>
        {icon ? <Icon name={icon} /> : null}
        {image && <img src={image} alt={imageAlt} className="w-100 h-100 object-fit-cover" />}
        {text && !image && <span>{text}</span>}
        {props.children}
      </div>

      {name ? (
        <div className="user-info">
          <div className="tb-lead multiline-ellipsis">{name}</div>
          {clientType && <div className="">{clientType}</div>}
          {subName && <div className="">{subName}</div>}
          {phoneNumber && <div className="">{phoneNumber}</div>}
          {email && <div className="">{email}</div>}
          {relations && <div className="">{relations}</div>}
          {statusBadge && <div className="">{statusBadge}</div>}
          {capHours > 0 && (
            <div>
              <span className="badge-sm me-1 my-1 badge bg-caphour">
                <span className="text-white"> Cap Hours: {capHours}</span>
              </span>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default UserAvatar;
